<template>
  <div class="container">
    <div class="selectconditons">
      <a-row :gutter="24">
        <a-col :xl="5"
          :lg="7"
          :md="8"
          :sm="24">
          <a-input ref="tempCode"
            v-model="inputGroup.tempCode"
            placeholder="模板编码"
            style="width: 100%; margin-right: 2%"
            @pressEnter=";(pagination.current = 1), getTableDateNew()">
            <a-icon slot="prefix"
              type="mobile" />
            <a-tooltip slot="suffix"
              title="要模板ID">
              <a-icon type="info-circle"
                style="color: rgba(0, 0, 0, 0.45)" />
            </a-tooltip>
          </a-input>
        </a-col>
        <a-col :xl="5"
          :lg="7"
          :md="8"
          :sm="24">
          <h-one-selec-tag style="width:100%"
            v-model="inputGroup.type"
            placeholder="短信类型"
            dictCode="message_type_code" />
        </a-col>
        <a-col :xl="5"
          :lg="7"
          :md="8"
          :sm="24">
          <div style="display: flex;">
            <div style="width: 89px;display: flex;justify-content: center;align-items: center;">短信来源:</div>
            <m-ore-select :showType="true"
              showTypeName="name"
              showTypeValue="id"
              v-model="inputGroup.sourceId"
              url="/base/busCommonMessageSourceNew/listAll"
              :asterisk="false"
              :params="{}"
              placeholder="短信来源">
            </m-ore-select>
          </div>
        </a-col>
        <a-col :xl="5"
               :lg="7"
               :md="8"
               :sm="24">
          <div style="display: flex;">
            <div style="width: 89px;display: flex;justify-content: center;align-items: center;">平台顺序:</div>
            <a-select
              show-search
              style="width: 100%"
              v-model="inputGroup.platformScheme"
            >
              <a-select-option :value="value.id" v-for="value in platformSchemeOpenion" :key="value.name">{{ value.name }}</a-select-option>
            </a-select>
          </div>
        </a-col>
        <a-col :xl="5"
          :lg="7"
          :md="8"
          :sm="24">
          <a-input v-model="inputGroup.contents"
            placeholder="模板内容"
            style="width: 100%; margin-right: 2%"
            @pressEnter=";(pagination.current = 1), getTableDateNew()">
            <a-icon slot="prefix"
              type="mail" />
            <a-tooltip slot="suffix"
              title="模糊查询模板内容">
              <a-icon type="info-circle"
                style="color: rgba(0, 0, 0, 0.45)" />
            </a-tooltip>
          </a-input>
        </a-col>
        <a-col :span="24"
          style="text-align: right; margin-right: 2%;padding-top: 12px;">
          <a-button type="primary"
            icon="search"
            @click=";(pagination.current = 1), getTableDateNew()">搜索</a-button>
          <a-button type="primary"
            @click="searchReset"
            icon="reload"
            style="margin-left: 8px">重置</a-button>
          <a-button type="primary"
            icon="plus"
            style="margin-left: 1%"
            @click="visible = true">添加模板</a-button>
        </a-col>
      </a-row>
    </div>

    <a-drawer title="模板信息"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="onClose"
      :maskClosable="false"
      width="50%">
      <add-message-temple @addTemple="addTempleResult"
        :templte="templte"></add-message-temple>
    </a-drawer>
    <div class="selectresulttable">
      <a-table :columns="columns"
        :data-source="data"
        :pagination="false"
        :scroll="{ x: 1560 }"
        :loading="loading"
        bordered>
        <span slot="action"
          slot-scope="text, record">
          <a-button type="link"
            @click="testRecord(record)"
            size="small"
            style="margin-right: 3px">修改</a-button>
        </span>
      </a-table>
      <div class="pageBar">
        <a-pagination size="small"
          style="margin-top: 1%; float: right"
          :current="pagination.current"
          :total="pagination.total"
          :show-total="(total, range) => `${range[0]}-${range[1]} 共 ${total} 条`"
          show-size-changer
          show-quick-jumper
          :showSizeChanger="true"
          :pageSize="pagination.pageSize"
          :pageSizeOptions="pagination.pageSizeOptions"
          @change="onChange"
          @showSizeChange="showSizeChange" />
      </div>
    </div>
  </div>
</template>


<script>
import { getMessageInfo, getMessageType, getSourcesSelecetOpion, getPlatformSchemeSelecetOpion } from '@/api/api'
import { postAction } from '@/api/manage'
import HOneSelecTag from './modules/HOneSelecTag.vue'
import MOreSelect from './modules/NAmeMOreSelect.vue'
import moment from 'moment'
import AddMessageTemple from './components/addMessageTemple'
//表格字段名称
const columns = [
  {
    title: '模板号',
    dataIndex: 'tempCode',
    key: 'tempCode',
    width: 80,
    align: 'center',
  },
  {
    title: '模板名',
    dataIndex: 'tempName',
    key: 'tempName',
    width: 100,
  },
  {
    title: '短信类型',
    dataIndex: 'type_dictText',
    key: 'type_dictText',
    width: 120,
    align: 'center',
  },
  {
    title: '发送内容',
    dataIndex: 'contents',
    key: 'contents',
    width: 700,
  },
  {
    title: '参数个数',
    dataIndex: 'paramsNum',
    key: 'paramsNum',
    width: 70,
    align: 'center',
  },
  {
    title: '备注',
    dataIndex: 'memo',
    key: 'memo',
    width: 90,
  },
  {
    title: '来源',
    dataIndex: 'sourceName',
    key: 'sourceName',
    width: 80,
    align: 'center',
  },
  {
    title: '平台顺序',
    dataIndex: 'platformSchemeName',
    key: 'platformSchemeName',
    width: 80,
    align: 'center',
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    key: 'createTime',
    width: 120,
    align: 'center',
  },
  {
    title: '修改时间',
    dataIndex: 'updateTime',
    key: 'updateTime',
    width: 120,
    align: 'center',
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    width: 80,
    align: 'center',
  },
]

export default {
  components: { AddMessageTemple, HOneSelecTag, MOreSelect },
  data() {
    return {
      visible: false,
      columns,
      data: [],
      //页码数据
      pagination: {
        current: 1,
        total: 0,
        pageSizeOptions: ['5', '10', '15', '20'],
        pageSize: 10,
      },
      //查询参数
      inputGroup: {
        tempCode: '',
        sourceId: '',
        platformScheme: null,
        contents: '',
        type: '',
      },
      loading: false,
      messageType: [],
      templte: null,
      //短信来源选择器数组
      sourceOpenion: [],
      platformSchemeOpenion: [],
      url: {
        list: '/base/busCommonMessageTemplateNew/list'
      }
    }
  },
  mounted() {
    this.getPlatformSchemeSelecet();
    //获取列表数据
    this.getTableDate();
  },
  methods: {
    /***
     * 重置
     */
    searchReset() {
      this.inputGroup = {};
      this.pagination.current = 1;
      this.getTableDateNew();
    },
    //获取选择器选项
    getMessageTypeOpenion() {
      getMessageType().then((res) => {
        this.messageType = res.result.value
        this.messageType.splice(0, 0, '全部')
      })
    },
    getPlatformSchemeSelecet() {
      getPlatformSchemeSelecetOpion().then((res) => {
        this.platformSchemeOpenion = res.result
        this.platformSchemeOpenion.splice(0, 0, {id:"",name:"（默认）"})
      })
    },
    //传值给子组件
    testRecord(data) {
      this.templte = data
      this.visible = true
    },
    //换页执行的方法
    onChange(page, pageSize) {
      this.loading = true
      this.pagination.current = page
      this.pagination.pageSize = pageSize
      this.loadData();
    },
    //修改页容量触发方法
    showSizeChange(current, size) {
      this.loading = true
      this.pagination.current = current
      this.pagination.pageSize = size
      this.loadData();
    },
    //日期组件
    moment,
    //获取表格数据
    getTableDate() {
      this.loading = true
      let requestParms = {
        id: this.$ls.get('Login_Userinfo').id,
      };
      getSourcesSelecetOpion(requestParms).then((res) => {
        if (res.success) {
          this.sourceOpenion = res.result
          this.sourceOpenion.splice(0, 0, { id: '', sources: '全部' })
          this.inputGroup.sourceId = this.sourceOpenion[0].id
          this.loadData();
        } else {
          this.$message.error('您没有权限！')
          this.loading = false
        }
      });
    },
    getTableDateNew() {
      this.loading = true
      this.loadData();
    },
    //关闭抽屉
    onClose() {
      this.visible = false
    },
    //接收模板组件传回的数据
    addTempleResult(data) {
      this.loading = true
      this.visible = data
      this.loadData();
    },
    loadData() {
      let parms = {
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
        sourceId: this.inputGroup.sourceId,
        platformScheme: this.inputGroup.platformScheme,
        tempCode: this.inputGroup.tempCode,
        contents: this.inputGroup.contents,
        type: this.inputGroup.type,
        userid: this.$ls.get('Login_Userinfo').id,
      }
      postAction(this.url.list, parms).then(res => {
        this.data = res.result.records
        this.pagination.current = res.result.current
        this.pagination.total = res.result.total
        this.loading = false
      })
    }
  },
}
</script>

<style scoped>
.container {
  background-color: #ffffff;
  height: 100%;
  width: 100%;
}
.selectconditons {
  padding-top: 1%;
  padding-left: 1%;
  background-color: #ffffff;
}
.selectresulttable {
  padding: 0.5%;
  background-color: #ffffff;
}
.pageBar {
  width: 100%;
  height: 3rem;
  background-color: #ffffff;
}
</style>
